import { motion } from 'framer-motion';
import { LayoutGridIcon, SparklesIcon, ShieldCheckIcon, FeatherIcon, GemIcon, StarIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
const EDITORIAL_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/3cb4e42c-8a01-41c1-bc2f-8f636dc11d78.jpg';
const KIT_ROSADO_URL = 'https://e04whn-0h.myshopify.com/products/kit-rosado-premium-para-extensiones-de-pestanas';
const KIT_NEGRO_URL = 'https://e04whn-0h.myshopify.com/products/kit-negro-premium-para-extensiones-de-pestanas';
const GOLD = '#C9A96E';
const benefits = [{
  icon: LayoutGridIcon,
  title: 'Organización inteligente',
  text: 'Todo en su lugar para trabajar con mayor rapidez.'
}, {
  icon: SparklesIcon,
  title: 'Elegancia profesional',
  text: 'Un diseño sofisticado que refleja la calidad de tu trabajo.'
}, {
  icon: ShieldCheckIcon,
  title: 'Protección de tus herramientas',
  text: 'Compartimentos diseñados para mantener cada accesorio seguro.'
}, {
  icon: FeatherIcon,
  title: 'Comodidad diaria',
  text: 'Ligero, práctico y fácil de transportar a cualquier cita.'
}, {
  icon: GemIcon,
  title: 'Materiales Premium',
  text: 'Fabricado con acabados elegantes y resistentes para el uso diario.'
}, {
  icon: StarIcon,
  title: 'Diseñado para destacar',
  text: 'Porque la presentación también forma parte de la experiencia del cliente.'
}];
export function ShopifyDescription() {
  return <section className="relative overflow-hidden px-6 py-32" style={{
    background: 'linear-gradient(180deg, #ffffff 0%, #fdfbf7 50%, #ffffff 100%)'
  }} data-id="element-305" data-mp="2i6i80u3udrq1">
      {/* Brand watermark */}
      <img src={LOGO_URL} alt="" aria-hidden="true" className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[85%] max-w-[900px] mix-blend-multiply opacity-[0.07] z-0" data-id="element-306" data-mp="2e2tirs2g1zy" />

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-307" data-mp="5027moqi4ut9">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-start" data-id="element-308" data-mp="wdyi1m81r5w">
          {/* Left — editorial photograph */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9
        }} className="lg:sticky lg:top-24" data-id="element-309" data-mp="3s3zy9j5tl9hh">
            <img src={EDITORIAL_IMAGE} alt="Lash artist profesional con su kit Alexa Beauty en un estudio de extensiones de pestañas" loading="lazy" decoding="async" className="w-full h-auto object-cover rounded-sm" data-id="element-310" data-mp="jnet6dgb70jn" />
            <p className="mt-6 text-xs tracking-[0.25em] uppercase text-gray-400 font-sans" data-id="element-311" data-mp="17czide322u1d">
              El kit como parte de tu forma de trabajar
            </p>
          </motion.div>

          {/* Right — persuasive content */}
          <div data-id="element-312" data-mp="19ygz2b33f2l6">
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-313" data-mp="19yyr0viq2una">
              <span className="text-xs font-medium tracking-[0.3em] uppercase block mb-6" style={{
              color: GOLD
            }} data-id="element-314" data-mp="1jxoautu6ip66">
                Información del Producto
              </span>

              <h2 className="text-3xl md:text-4xl font-serif text-luxury-black leading-tight mb-8" data-id="element-315" data-mp="1xvcvc0kc3uap">
                Más que un kit. Una herramienta para elevar tu imagen
                profesional.
              </h2>

              <p className="text-base md:text-lg text-gray-600 font-sans font-light leading-relaxed" data-id="element-316" data-mp="27lpd5l0rl9d5">
                No todas las profesionales utilizan las mismas herramientas. Las
                mejores eligen productos que transmiten organización, elegancia
                y confianza desde el primer momento.
              </p>
            </motion.div>

            {/* Body copy */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.15
          }} className="mt-12 space-y-6 text-base text-gray-600 font-sans font-light leading-relaxed" data-id="element-317" data-mp="39bvxyld1ecxf">
              <p data-id="element-318" data-mp="2vcnx7o186wr4">
                Cada cliente percibe los pequeños detalles. Llegar con un kit
                elegante, bien organizado y diseñado para proteger tus
                herramientas también comunica profesionalismo.
              </p>
              <p data-id="element-319" data-mp="2zdg8emtnrbq1">
                Alexa Beauty fue creado para lash artists y profesionales de la
                belleza que quieren ofrecer una experiencia impecable en cada
                cita.
              </p>
              <p className="text-luxury-black" data-id="element-320" data-mp="enhc5alz6r39">
                Porque una imagen profesional comienza mucho antes de iniciar el
                servicio.
              </p>
            </motion.div>

            {/* Benefits grid */}
            <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-10" data-id="element-321" data-mp="r6mhqgwxtcxb">
              {benefits.map(({
              icon: Icon,
              title,
              text
            }, index) => <motion.div key={title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index % 2 * 0.1
            }} className="flex items-start gap-4" data-id="element-322" data-mp="i4wr3davqi0l" data-mpi={index}>
                  <Icon className="w-5 h-5 shrink-0 mt-1" style={{
                color: GOLD
              }} aria-hidden="true" data-id="element-323" data-mp="w4ej01jh2be6" />
                  <div data-id="element-324" data-mp="1osk3qoaj00e0">
                    <h3 className="font-serif text-lg text-luxury-black mb-2" data-id="element-325" data-mp="1osadr0phdt8b">
                      {title}
                    </h3>
                    <p className="text-sm text-gray-500 font-sans font-light leading-relaxed" data-id="element-326" data-mp="23gacqq65as00">
                      {text}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            {/* Color selector */}
            <motion.div id="disponible-en" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="mt-20 scroll-mt-24" data-id="element-327" data-mp="1tgb8h5grdnsy">
              <p className="font-serif text-xl md:text-2xl text-luxury-black mb-8" data-id="element-328" data-mp="1fpetihfr954d">
                Elige el estilo que mejor representa tu marca.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-329" data-mp="15tl6u58bnv8v">
                <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-rosado-soft px-4 py-2 rounded-full text-sm text-luxury-black border border-rosado-light/50" data-id="element-330" data-mp="11r83fnh1s9f9">
                  🌸 Rosado Premium
                </a>
                <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-luxury-black px-4 py-2 rounded-full text-sm text-white" data-id="element-331" data-mp="3hfvq5145n2sk">
                  🖤 Negro Luxury
                </a>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Emotional statement */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="mt-32 text-center" data-id="element-332" data-mp="2yp5qdl9vrw3x">
          <p className="font-serif italic text-xl md:text-3xl text-luxury-black leading-relaxed max-w-2xl mx-auto" data-id="element-333" data-mp="25zyme6rnqeba">
            "La confianza de tus clientes comienza con la imagen que proyectas."
          </p>

          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9,
          delay: 0.3
        }} className="mx-auto mt-10 h-[1px] w-24 origin-center" style={{
          backgroundColor: GOLD
        }} data-id="element-334" data-mp="14cr3y7z44whm" />
        </motion.div>
      </div>
    </section>;
}